import { render, staticRenderFns } from "./Pointer.vue?vue&type=template&id=b2ff8956&scoped=true&lang=pug&"
import script from "./Pointer.vue?vue&type=script&lang=js&"
export * from "./Pointer.vue?vue&type=script&lang=js&"
import style0 from "./Pointer.vue?vue&type=style&index=0&id=b2ff8956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ff8956",
  null
  
)

export default component.exports